export default __webpack_public_path__ + "static/media/toggle-in.55f1be79.svg";